const selectPageEntryById = pageId => data => {
  const page = data?.data.pages.find(it => it.id === pageId);
  if (!page) {
    return createEmptyPageEntry(pageId);
  }
  return page;
};
const EMPTY_PAGE_ENTRIES = new Map();
function createEmptyPageEntry(pageId) {
  if (!EMPTY_PAGE_ENTRIES.has(pageId)) {
    EMPTY_PAGE_ENTRIES.set(pageId, {
      id: pageId,
      items: {},
      clones: [],
      drawings: [],
      lines: []
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return EMPTY_PAGE_ENTRIES.get(pageId);
}

export { selectPageEntryById };
//# sourceMappingURL=entry.page-by-id.js.map
